'use client';

import type { FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
  Dialog,
  DialogActionClose,
  DialogActionPrimary,
  DialogActions,
  DialogContent,
} from '@sola/ark-core/molecules/dialog/dialog.tsx';
import { EmailField } from '@sola/ark-core/molecules/email-field/email-field.tsx';
import { Form } from '@sola/ark-core/molecules/form/form.tsx';
import { InputField } from '@sola/ark-core/molecules/input-field/input-field.tsx';
import type { ModalProps } from '@sola/ark-core/molecules/modal/modal.js';
import { PhoneField } from '@sola/ark-core/molecules/phone-field/phone-field.tsx';
import { COUNTRY_CODE_US } from '@sola/schema/dotcom/shared/geo.ts';
import type { SupporterDetailsData } from '@sola/supporter-sdk/queries.ts';

export const EditContactInfoModal = ({
  supporter,
  open,
  onOpenChange,
  onClose,
}: {
  supporter: SupporterDetailsData;
  open: ModalProps['open'];
  onOpenChange: ModalProps['onOpenChange'];
  onClose: ModalProps['onClose'];
}) => {
  const defaultFormValues = {
    firstname: supporter?.firstName,
    lastname: supporter?.lastName,
    preferredName: supporter?.preferredName,
    email: supporter?.email,
    phone: supporter?.mobilePhone,
  };

  const { t } = useTranslation(['core', 'my-settings']);

  const handleSubmit = async (data: FieldValues) => {
    console.log('handleSubmit');
    //TODO: Integrate with contact information hook
    onClose?.();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        icon="user-edit"
        title={t('my-settings:form.contactInformation.title')}
      >
        <Form
          onSubmit={handleSubmit}
          options={{
            defaultValues: defaultFormValues,
          }}
        >
          <InputField
            key="firstname"
            name="firstname"
            label={t('my-settings:form.contactInformation.firstNameLabel')}
            required
          />
          <InputField
            key="lastname"
            name="lastname"
            label={t('my-settings:form.contactInformation.lastNameLabel')}
            required
          />
          <InputField
            key="preferredName"
            name="preferredName"
            label={t('my-settings:form.contactInformation.preferredName')}
            hint={t('my-settings:form.contactInformation.preferredNameHelper')}
          />
          <EmailField
            key="email"
            name="email"
            required
            label={t('my-settings:form.contactInformation.emailAddress')}
          />
          <PhoneField
            key="phone"
            name="phone"
            label={t('my-settings:form.contactInformation.phoneNumberLabel')}
            countryCode={COUNTRY_CODE_US}
          />
          <DialogActions>
            <DialogActionClose>{t('core:actions.cancel')}</DialogActionClose>
            <DialogActionPrimary type="submit">
              {t('core:actions.save')}
            </DialogActionPrimary>
          </DialogActions>
        </Form>
      </DialogContent>
    </Dialog>
  );
};
